import React, {useCallback, useEffect, useState} from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {login, loginFailure} from "../../store/main/action";



const LogMain = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const formErr = useSelector(store => store.main.loginErr);
    const authStatus = useSelector(store => store.main.authorizationStatus);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const sendFormHandler = useCallback(()=>{
        dispatch(login({email, password}));
    }, [email, password, dispatch])

    useEffect(()=>{
        if (authStatus){
            navigate('/cabinet');
        }
    },[authStatus, navigate])

    useEffect(() => {
        const onKeyDown = e => {
            if(e.keyCode === 13) {
                sendFormHandler();
            }
        };
        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, [sendFormHandler]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.formWrap}`}>
                    <div className={`${Styles.formTitle}`}>{t('Вход')}</div>
                    <div className={`${Styles.contentBox}`}>
                        <div className={`${Styles.inputWrap} ${formErr?.email ? Styles.inputWrapWithErr : null}`}>
                            <div className={`${Styles.inputTitle}`}>{t('Почта')}</div>
                            <input
                                className={`${Styles.tcInput}`}
                                type="text"
                                placeholder="example@gmail.com"
                                value={email}
                                onChange={(e)=>{setEmail(e.target.value)}}
                                onKeyDown={(event)=>{
                                    if (formErr.email){
                                        delete formErr.email;
                                        dispatch(loginFailure(formErr));
                                    }
                                }}
                            />
                            <div className={`${Styles.tcErr} ${formErr?.email ? Styles.tcErrActive : null}`}>{formErr?.email ? formErr.email : null}</div>
                        </div>
                        <div className={`${Styles.inputWrap} ${formErr?.password ? Styles.inputWrapWithErr : null}`}>
                            <div className={`${Styles.inputTitle}`}>{t('Пароль')}</div>
                            <input
                                className={`${Styles.tcInput}`}
                                type="password"
                                placeholder="••••••••"
                                value={password}
                                onChange={(e)=>{setPassword(e.target.value)}}
                                onKeyDown={(event)=>{
                                    if (formErr.password){
                                        delete formErr.password;
                                        dispatch(loginFailure(formErr));
                                    }
                                }}
                            />
                            <div className={`${Styles.tcErr} ${formErr?.password?.[0] ? Styles.tcErrActive : null}`}>{formErr?.password?.[0] ? formErr.password[0] : null}</div>
                        </div>
                    </div>
                    <div className={`${Styles.note}`}>
                        <span onClick={()=>{navigate('/forgot-password')}}>{t('Забыли пароль?')}</span>
                    </div>
                    <div className={`${Styles.note}`}>{t('У вас ещё нет аккаунта?')} <span onClick={()=>{navigate('/sign-up')}}>{t('Регистрация')}</span></div>
                    <div className={`${Styles.tcBtn}`} onClick={()=>{sendFormHandler()}}>{t('Вход')}</div>
                </div>
            </div>
        </section>
    );
};

export default LogMain;